import { TreeItem } from "@mui/x-tree-view";
import { makeStyles } from "tss-react/mui";

const useStyles: any = makeStyles()((theme: any) => ({
    root: {
        color: theme.palette.text.secondary,
        "&:hover > $content": {
            backgroundColor: theme.palette.action.hover,
        },
        "&:focus > $content, &$selected > $content": {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
            color: "var(--tree-view-color)",
        },
        "&:focus > $content $label, &:hover > $content $label, &$selected > $content $label": {
            backgroundColor: "transparent",
        },
    },
    content: {
        color: theme.palette.text.secondary,
        paddingLeft: theme.spacing(1),
        paddingRight: -theme.spacing(1),
        fontWeight: theme.typography.fontWeightMedium,
        "$expanded > &": {
            fontWeight: theme.typography.fontWeightRegular,
        },
    },
    group: {
        //marginLeft: 0,
        "& $content": {
            paddingLeft: theme.spacing(2),
        },
    },
    expanded: {},
    selected: {},
    label: {
        fontWeight: "inherit",
        color: "inherit",
    },
}));

type IProps = {
    nodeId: string;
    label: any;
    children?: any;
    style?: any;
    onClick?: any;
};

export default function StyledTreeItem(props: IProps) {
    const { classes } = useStyles();
    const { nodeId, label, children, style, onClick } = props;
    return (
        <TreeItem
            style={style}
            onClick={onClick}
            label={label}
            classes={{
                root: classes.root,
                content: classes.content,
                expanded: classes.expanded,
                selected: classes.selected,
                label: classes.label,
            }}
            itemId={nodeId}
        >
            {children}
        </TreeItem>
    );
}
